import React from "react";

const ErrorPage = () => {
  return <div>Stranica nije pronadjena</div>;
};

export default ErrorPage;
